export const dbTabs1 = {
  presentation: {
    descriptionTitle: "Listing description",
    descriptionSub: "Choose whether the description appears on the direct booking page for each unit.",
    visible: "Visible",
    hidden: "Hidden",
    amenitiesTitle: "Included services",
    amenitiesSub: "Define which services and amenities are shown for each unit in your booking engine.",
    amenitiesCount: "{count} service | {count} services",
    editAmenitiesTitle: "Edit services",
    edit: "Edit",
    imagesTitle: "Accommodation images",
    imagesSubtitle: "Upload, reorder and set the main image of each unit that will appear in your booking engine.",
  },
  reservations: {
    updating: "Updating…",
    engineActive: "Engine active",
    engineInactive: "Engine inactive",
    engineActiveDesc: "Guests can book rooms directly from your link.",
    engineInactiveDesc: "Direct bookings are disabled for this hotel.",
    statusActive: "Active",
    statusInactive: "Inactive",
    roomsAvailable: "Available rooms",
    colRoom: "Room",
    colCap: "Cap.",
    colActive: "Active",
    noRooms: "No rooms configured.",
    hotelLabel: "Hotel",
    unitActive: "Active",
    unitInactive: "Inactive",
    enableNotice: "Enable direct bookings to manage rooms.",
    toastUpdated: "Updated.",
    toastUpdateError: "Couldn't update.",
    toastGlobalUpdated: "Global status updated.",
  },
  promotions: {
    title: "Promotions on direct booking",
    subtitle: "Control which ones are active, whether they can stack and their order.",
    loading: "Loading promotions…",
    empty: "No promotions configured for this property.",
    dragTitle: "Drag to reorder",
    switchTitle: "Active on direct booking",
    badgeLabel: "Badge",
    badgePlaceholder: "e.g. -10% / Deal",
    stackableLabel: "Stackable",
    tip: "Tip: turn on the promotion to apply it on direct booking and use “Stackable” if it can combine with other promos.",
    toastLoadError: "Couldn't load the promotions.",
    toastSaved: "Promotions saved successfully.",
    toastSaveError: "Couldn't save the promotions.",
    dateFrom: "From {date}",
    dateUntil: "Until {date}",
  },
  addons: {
    title: "Occupancy and charges",
    hint1: "A single adjustment per {scope}: reduction for fewer guests",
    hintOr: "or",
    hint2: "surcharge per extra guest. Not both.",
    perRoom: "room",
    perAccommodation: "accommodation",
    loading: "Loading configuration…",
    emptyHotel: "This hotel has no rooms configured.",
    thisAccommodation: "This accommodation",
    modeReduction: "Reduction",
    modeSurcharge: "Surcharge",
    modeNone: "No adjustment",
    toastLoadError: "Couldn't load the occupancy configuration.",
    toastSaved: "Occupancy saved successfully.",
    toastSaveError: "Couldn't save the occupancy.",
  },
};
